import React, { ChangeEvent } from 'react';
import lien from '../../assets/lien.png';

type Props = {
    link: string;
    handleLinkChange: (e: ChangeEvent<HTMLInputElement>) => void;
    media: string;
    isViewOnly: boolean;
};

export function LinkPublicationInput({ link, handleLinkChange, media, isViewOnly }: Props) {
    return (
        <div>
            <label htmlFor="link">Ajouter un lien</label>
            <input
                className="w-full"
                name="link"
                type="url"
                value={link}
                onChange={handleLinkChange}
                placeholder="Ajouter un lien"
                disabled={!!media && media !== lien}
                readOnly={isViewOnly}
            />
        </div>
    );
}
